import { useRef } from 'react';
import { motion } from 'framer-motion';
import { useSeen } from '@/lib/experience';

/** Entra "quicando" quando chega na tela (robusto a saltos de scroll). */
export const Reveal = ({ as = 'div', x = 0, y = 40, rotate = 0, scale = 0.92, delay = 0, offset = 0.9, className = '', children, ...rest }) => {
  const ref = useRef(null);
  const seen = useSeen(ref, offset);
  const Tag = motion[as] || motion.div;
  const hidden = { opacity: 0, x, y, rotate, scale };
  return (
    <Tag
      ref={ref}
      className={className}
      initial={hidden}
      animate={seen ? { opacity: 1, x: 0, y: 0, rotate: 0, scale: 1 } : hidden}
      transition={{ type: 'spring', stiffness: 260, damping: 16, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
